import axios from "axios";
import { store } from "../index";
import { apiEndpointFailed } from "../actions/commonActions";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  ({ response }) => {
    if ([500, 503, 504, 404, 400].includes(response.status)) {
      let responseObject = {
        errorStatusCode: response.status,
        message: response.data.message,
        error:
          (response.data.response.error
            ? response.data.response.error
            : response.statusText) || response.data.message,
      };

      apiEndpointFailed(store.dispatch, true, responseObject);
    }
    return Promise.reject(response);
  }
);

export default axios;
